import { apiGet } from '@/lib/http/client';

import type { MailchimpSyncHealthResponse } from '../types';

export async function getMailchimpSyncHealth(
  orgId: number | string
): Promise<MailchimpSyncHealthResponse> {
  return apiGet<MailchimpSyncHealthResponse>(
    `/api/orgs/${orgId}/mailchimp/sync-health/`
  );
}
